import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { MedalTally } from './MedalTally'

export interface MedalTallyRouteProps {
    isFullSize: boolean
}

export const MedalTallyRegistration = createRegisterableComponent(
    'stats-medal-tally',
    (props: MedalTallyRouteProps) => {
        return <MedalTally isFullSize={props.isFullSize} />
    },
)
